/**
 * Utility functions for managing background and theme transitions
 */

/**
 * Sets the body background color based on the current theme
 */
export const setBodyBackground = (): void => {
  const isDarkMode = document.documentElement.classList.contains("dark");

  document.body.style.backgroundImage = "none";

  if (isDarkMode) {
    // Dark mode: Deep warm dark brown
    document.body.style.background = "#18150F";
  } else {
    // Light mode: Warm cream
    document.body.style.background = "#FAF8F4";
  }

  document.body.style.backgroundSize = "100% 100%";
  document.body.style.backgroundPosition = "center";
  document.body.style.backgroundAttachment = "fixed";
  document.body.style.backgroundRepeat = "no-repeat";
};

/**
 * Updates the background when theme changes
 */
export const updateOverlay = (): void => {
  setBodyBackground();
};
